import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'

Vue.use(Router)

let router = new Router({
	mode: 'history',
	routes: [
		{ path: '/index.html', component: Home, name: 'homeIndex', alias: '/' },
		{ path: '/app/index.html', component: Home, name: 'homeIndex', alias: '/' },
		{
			path: '/',
			name: 'home',
			component: Home,
		},
		{
			path: '/doctors/:especiality?/:region?',
			name: 'DoctorList',
			component: () => import(/* webpackChunkName: "DoctorList" */ '@/views/DoctorList.vue'),
		},
		{
			path: '/doctor/:id-:slug',
			name: 'DoctorProfile',
			component: () => import(/* webpackChunkName: "DoctorProfile" */ '@/views/DoctorProfile.vue'),
		},

		{
			path: '/clinics/:service?/:region?',
			name: 'ClinicList',
			component: () => import(/* webpackChunkName: "DoctorList" */ '@/views/ClinicList.vue'),
		},
		{
			path: '/clinic/:id-:slug',
			name: 'ClinicProfile',
			component: () => import(/* webpackChunkName: "DoctorProfile" */ '@/views/ClinicProfile.vue'),
		},

		{
			path: '/checkout',
			name: 'Checkout',
			component: () => import(/* webpackChunkName: "Checkout" */ '@/views/Checkout.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/checkout/:code/payment',
			name: 'CheckoutResult',
			component: () => import(/* webpackChunkName: "CheckoutResult" */ '@/views/CheckoutResult.vue'),
			meta: {
				requiresAuth: true,
			},
		},

		{
			path: '/service-checkout',
			name: 'CheckoutService',
			component: () => import(/* webpackChunkName: "Checkout" */ '@/views/CheckoutService.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/service-checkout/:code/payment',
			name: 'CheckoutResult',
			component: () => import(/* webpackChunkName: "CheckoutResult" */ '@/views/CheckoutServiceResult.vue'),
			meta: {
				requiresAuth: true,
			},
		},

		{
			path: '/about',
			name: 'about',
			component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
		},
		{
			path: '/faqs',
			name: 'faqs',
			component: () => import(/* webpackChunkName: "faqs" */ '@/views/Faqs.vue'),
		},
		{
			path: '/terms',
			name: 'terms',
			component: () => import(/* webpackChunkName: "terms" */ '@/views/Terms.vue'),
		},
		{
			path: '/privacy',
			name: 'privacy',
			component: () => import(/* webpackChunkName: "privacy" */ '@/views/Privacy.vue'),
		},
		{
			path: '/contact',
			name: 'contact',
			component: () => import(/* webpackChunkName: "contract" */ '@/views/Contact.vue'),
		},
		{
			path: '/login',
			name: 'login',
			component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
		},
		{
			path: '/logout',
			name: 'logout',
			component: () => import(/* webpackChunkName: "logout" */ './views/Logout.vue'),
		},
		{
			path: '/register',
			name: 'register',
			component: () => import(/* webpackChunkName: "register" */ '@/views/Register.vue'),
		},
		{
			path: '/forgot-password',
			name: 'ForgotPassword',
			component: () => import(/* webpackChunkName: "forgotPassword" */ './views/ForgotPassword.vue'),
		},
		{
			path: '/password-change',
			name: 'PasswordChange',
			component: () => import(/* webpackChunkName: "PasswordChange" */ '@/views/PasswordChange.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/sitemap',
			name: 'Sitemap',
			component: () => import(/* webpackChunkName: "PasswordChange" */ '@/views/Sitemap.vue'),
		},
		{
			path: '/profile',
			name: 'profile',
			component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/profile/personal-data',
			name: 'personal-data',
			component: () => import(/* webpackChunkName: "profile" */ '@/views/ProfilePersonalData.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/profile/medical',
			name: 'medical',
			component: () => import(/* webpackChunkName: "profile" */ '@/views/ProfileMedical.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/bookings',
			name: 'bookings',
			component: () => import(/* webpackChunkName: "bookings" */ '@/views/Bookings.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/bookings/:id',
			name: 'bookingDetail',
			component: () => import(/* webpackChunkName: "bookingDetail" */ '@/views/BookingDetail.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/bookings/:id/attend',
			name: 'bookingAttend',
			component: () => import(/* webpackChunkName: "bookingDetail" */ '@/views/BookingAttend'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/bookings/:id/rate',
			name: 'bookingRate',
			component: () => import(/* webpackChunkName: "bookingDetail" */ '@/views/BookingRate'),
			meta: {
				requiresAuth: true,
			},
		},

		{
			path: '/clinic-services',
			name: 'clinicServices',
			component: () => import(/* webpackChunkName: "bookings" */ '@/views/ClinicServices.vue'),
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: '/clinic-services/:id',
			name: 'clinicServiceDetail',
			component: () => import(/* webpackChunkName: "bookingDetail" */ '@/views/ClinicServiceDetail.vue'),
			meta: {
				requiresAuth: true,
			},
		},

		{
			path: '/exams',
			name: 'exams',
			component: () => import(/* webpackChunkName: "bookingDetail" */ '@/views/Exams.vue'),
		},
	],
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
})

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (store.getters.isAuthenticated) {
			next()
			return
		}
		next('/login')
	} else {
		next()
	}
})

export default router
